// © Microsoft Corporation. All rights reserved.

/**
 * The name of the cookie dropped by MSCC framework when consent is given.
 */
export const msccCookieName = "MSCC";

/**
 * An enumeration indicating the cookie consent status.
 */
export enum CookieConsentStatus {
    /**
     * Consent status has not been resolved yet.
     */
    Unknown,
    /**
     * Consent is required and is not yet provided.
     */
    Required,
    /**
     * Consent is not required. This could be because user is in a market where consent is not needed, or consent has already been provided.
     */
    NotRequired
}

/**
 * An enumeration indicating the cookie consent provider.
 */
export enum CookieConsentProvider {
    /**
     * Consent status is provided by the MSCC banner.
     */
    MSCCBanner = "mscc",
    /**
     * Consent status is provided by the Cookie wall.
     */
    CookieWall = "cookiewall",
    /**
     * Consent status is provided by the OneTrust banner.
     */
    OneTrustBanner = "onetrust",
    /**
     * Consent status is provided by the Widget host page.
     */
    WidgetHost = "widgethost",
    /**
     * Consent status is not provided by anyone since it's not required.
     */
    None = "none"
}

/**
 * Cookie consent info interface
 */
export interface CookieConsentInfo {
    consentProvider: CookieConsentProvider,
    consentStatus: CookieConsentStatus
}